import React from 'react'
import '../CSS/Loader.css'

const Loader = () => {
  return (
    <>
      <div className='backLoader'>
        <h1 className="start">
            <span className="end1">PRO</span><span class="middle1">Suprodip</span>
            <span className="end2">VIDER</span>
        </h1>
      </div>
    </>
  )
}

export default Loader